import { render } from "./CreateDriver.vue?vue&type=template&id=3609bfcc&scoped=true"
import script from "./CreateDriver.vue?vue&type=script&lang=js"
export * from "./CreateDriver.vue?vue&type=script&lang=js"

import "./CreateDriver.vue?vue&type=style&index=0&id=3609bfcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3609bfcc"]])

export default __exports__